<template>
  <div class="home">
    <van-cell-group>
      <van-cell title="科目">
        <template slot="label">
          <van-row gutter="20">
            <van-col
              span="8"
              v-for="(item, index) in subject"
              :key="index"
              @click="setSubject(item.name)"
            >
              <van-image :src="item.img" fit="contain" />
              <!-- <img :alt="item.name" /> -->
              <div>{{ item.name }}</div>
            </van-col>
          </van-row>
        </template>
      </van-cell>
      <van-cell title="年级">
        <template slot="label">
          <div class="labelbox">
            <van-row gutter="12">
              <van-col span="8" v-for="(item, index) in grade" :key="index">
                <van-button
                  round
                  block
                  size="small"
                  @click="setGrade(item.id)"
                  class="tag"
                  :class="{ tagon: item.id == gradeId }"
                  >{{ item.name }}</van-button
                >
              </van-col>
            </van-row>
          </div>
        </template>
      </van-cell>
    </van-cell-group>
    <div class="footer">
      <van-button block color="#409EFF" @click="goUrl">确定</van-button>
    </div>
    <loadingPage :isShow="loading"></loadingPage>
  </div>
</template>

<script>
import { assessApi } from "@/api/index";
import weixinshare from "@/wxsdk/share";
import loadingPage from './loading'
export default {
  name: "home",
  components: {
    loadingPage
  },
  data() {
    return {
      loading: true,
      gradeId: 0,
      subjectId: 0,
      subject: [],
      grade: []
    };
  },
  mounted() {
    this.getSubject();
    const linkurl = "https://" + window.location.host;
    weixinshare(this.$titles, linkurl, this.$imgurls, this.$descs);
  },
  methods: {
    setGrade(id) {
      this.gradeId = id;
      sessionStorage.setItem("gradeId", id);
    },
    setSubject(name) {
      this.subject.forEach(item => {
        if (item.name == name) {
          item.img = item.imagesOn;
          this.subjectId = item.id;
          this.getGrade(item.id);
          sessionStorage.setItem("subject", name);
          sessionStorage.setItem("subjectId", item.id);
        } else {
          item.img = item.images;
        }
      });
    },
    goUrl() {
      this.$router.push({
        name: "list",
        params: { sid: this.subjectId, gid: this.gradeId }
      });
    },
    getGrade(id) {
      let params = {
        subjectId: id
      };
      assessApi.getGrade(params).then(res => {
        if (res.success) {
          this.grade = res.data;
          this.gradeId = sessionStorage.getItem("gradeId")
            ? sessionStorage.getItem("gradeId")
            : res.data[0]["id"];
        } else {
          this.$toast.fail("获取年级失败");
        }
      });
    },
    getSubject() {
      assessApi.getSubjects().then(res => {
        this.loading = false
        if (res.success) {
          let id = sessionStorage.getItem("subjectId")
            ? sessionStorage.getItem("subjectId")
            : 0;
          let data = res.data.map(item => {
            switch (item.name) {
              case "数学":
                if (id == 0) {
                  id = item.id;
                }
                item.img = require("../assets/math.svg");
                item.images = require("../assets/math.svg");
                item.imagesOn = require("../assets/math_on.svg");
                break;
              case "化学":
                item.img = require("../assets/chemi.svg");
                item.images = require("../assets/chemi.svg");
                item.imagesOn = require("../assets/chemi_on.svg");
                break;
              case "物理":
                item.img = require("../assets/physics.svg");
                item.images = require("../assets/physics.svg");
                item.imagesOn = require("../assets/physics_on.svg");
                break;
            }
            return item;
          });
          this.subject = data;
          let onSubject = sessionStorage.getItem("subject")
            ? sessionStorage.getItem("subject")
            : "数学";
          this.setSubject(onSubject);
          this.getGrade(id);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.home {
  padding-top: 5px;
  [class*="van-hairline"]::after {
    border-top: 0 solid #ebedf0;
  }
  .van-cell {
    font-size: 15px;
    .van-cell__label {
      margin-top: 8px;
    }
  }
  .labelbox {
    padding: 0 15px;
  }
  .van-col {
    text-align: center;
    font-size: 14px;
    color: #606266;
    margin: 6px 0;
    /deep/ .van-image__img {
      width: 70%;
      margin: 0 auto;
    }
    .tag {
      background: #dcdfe6;
      border: 1px solid #dcdfe6;
    }
    .tagon {
      background: #67c23a;
      color: #fff;
    }
  }
  .footer {
    width: 90%;
    position: fixed;
    left: 5%;
    bottom: 12px;
  }
}
</style>
